import React from "react";

function BlogHero() {
  return (
    <section
      style={{
        background:
          "linear-gradient(135deg, #002147 0%, #003d5c 100%)",
        color: "#ffffff",
        padding: "140px 20px",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          textAlign: "center",
        }}
      >
        <span
          style={{
            display: "inline-block",
            background: "rgba(255,255,255,0.12)",
            padding: "10px 18px",
            borderRadius: "999px",
            marginBottom: "24px",
            fontWeight: 600,
          }}
        >
          Insights • Growth • Strategy
        </span>

        <h1
          style={{
            fontSize: "clamp(3rem, 5vw, 5rem)",
            fontFamily: "Playfair Display, serif",
            marginBottom: "24px",
            lineHeight: 1.1,
          }}
        >
          Growth Insights For Modern Businesses
        </h1>

        <p
          style={{
            maxWidth: "800px",
            margin: "0 auto",
            color: "#e2e8f0",
            lineHeight: 1.9,
            fontSize: "1.15rem",
          }}
        >
          Actionable articles covering SEO, marketing,
          websites, analytics, automation and business
          growth strategies designed for ambitious brands.
        </p>
      </div>
    </section>
  );
}

export default BlogHero;